import React, {
  forwardRef,
  useEffect,
  useState,
} from 'react';
import { PAGE_SIZE } from '../../redux/constants';
// Componentes.
import {
  Dialog,
  Button,
  DialogContentText,
  Slide,
  DialogActions,
  Grid,    
  IconButton,
  Toolbar,
  AppBar,
  Typography,
  Checkbox
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// Componentes propios
import CustomNoRows from '../custom/CustomNoRows';
import msgNotificacion from '../../scripts/notification';
import Formatter from '../../scripts/formatters';
import Item from '../custom/Item';
import PermisoDataGrid from '../styledDataGrid/PermisosDataGrid';

// Servicios
import SeguridadService from '../../services/seguridadService';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

const ModalPermisos = ({ setOpenModal, openModal, usuario }) => {
  const [loading, setLoading] = useState(false)
  const [dataPermisos, setDataPermisos] = useState([])  

  function RenderCheckBox(props) {
    const [checked, setChecked] = useState(props.value) // Valor vinculado de reacción iniciada con parámetro de "filas"
    
    // Controlador de clics del usuario para establecer la casilla de verificación o desactivarla.
    const handleChange = (event) => {
      setChecked(event.target.checked)
      
      const row = props.row
      const permisosIndex = dataPermisos.filter(item => item.Consecutivo === row.Consecutivo)
      let permisos = [...dataPermisos]
      const index = dataPermisos.indexOf(permisosIndex[0])
      const acceso = event.target.checked

      permisos[index].IsAcceso = acceso

      setDataPermisos(permisos)
    }

    return (
      <Checkbox
        label="some text"
        size='medium'
        checked={checked} 
        onChange={handleChange}
        disabled={props.field === 'IsSubMenu' ? true : false}
      />
    );
  }

  const columnsPermisos = [
    { 
      field: 'Consecutivo',
      headerName: 'No.',
      headerAlign: 'center',
      align: 'center',
      minWidth: 80,
    },
    { 
      field: 'IdMenu', 
      headerName: 'Id Menu',
      headerAlign: 'center',
      align: 'center',
      minWidth: 80, 
    },
    { 
      field: 'Menu', 
      headerName: 'Menú',
      headerAlign: 'center',
      align: 'center',
      minWidth: 150,
      flex: 1
    },
    { 
      field: 'UrlPath', 
      headerName: 'Url de Acceso', 
      headerAlign: 'center',
      align: 'center',      
      minWidth: 150,
      flex: 1
    },
    { 
      field: 'IsSubMenu', 
      headerName: 'SubMenú',
      headerAlign: 'center',
      align: 'center',      
      minWidth: 100,
      flex: 1,
      renderCell: RenderCheckBox
    },
    { 
      field: 'IsAcceso', 
      headerName: 'Acceso',
      headerAlign: 'center',
      align: 'center',      
      minWidth: 100,
      flex: 1,
      renderCell: RenderCheckBox
    },
  ]
  
  const handleClose = () => {
    setOpenModal(false)
  }

  const getDetallePermisos = async (dataRequest) => {
    try {
      setDataPermisos([])
      
      setLoading(true)
      SeguridadService.getPermisos(dataRequest)
      .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            setLoading(false)
            return
          }
                    
          setTimeout(() => {
            if (response.Codigo === 1) {
              setDataPermisos(response.Data)
            } else {
              msgNotificacion(response.Mensaje, 'info')
            }

            setLoading(false)
          }, 500)
      })
      .catch((error) => {        
        msgNotificacion(error, 'error')
      })
    } catch (error) {
      console.error(error)
    }
  }

  const saveChanges = async () => {
    try {
      setLoading(true)

      SeguridadService.actualizarPermisos(dataPermisos)
      .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            setLoading(false)
            return
          }
          
          setTimeout(() => {
            if (response.Codigo === 1) {
              msgNotificacion(response.Mensaje, 'success')
            } else {              
              msgNotificacion(response.Mensaje, 'warning')
            }

            setOpenModal(false)
            setLoading(false)
          }, 100)
      })
      .catch((error) => {        
        msgNotificacion(error, 'error')
      })
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    const data = {
      codUsuario: usuario?.Id
    }
    
    if (openModal) {      
      getDetallePermisos(data)
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal])

  return (
    <div>
      <Dialog
        open={openModal}
        TransitionComponent={Transition}
        fullScreen
        slotProps={{
          backdrop: {
            timeout: 500
          }
        }}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">              
              <span>Permisos del usuario: <strong style={{ color: 'greenyellow', textDecoration: 'underline' }}>{usuario?.Nombre}</strong></span>
            </Typography>
          </Toolbar>
        </AppBar>
        <Grid container spacing={1} className='px-2 py-2'>
          <Grid item xs={12} md={12}>
            <DialogContentText className='bg-danger text-white'>
              Menús de acceso
            </DialogContentText>
            <Item style={{ height: 'calc(100vh - 160px)' }}>
              <PermisoDataGrid 
                rows={dataPermisos}
                getRowId={(row) => row.Consecutivo}
                columns={columnsPermisos}
                pageSize={PAGE_SIZE}
                pageSizeOptions={[10, 20, 50, 100]}
                loading={loading}
                localeText={Formatter.localizedTextsMapColumns}                
                showCellVerticalBorder
                showColumnVerticalBorder
                getRowClassName={(params) => `super-app-theme--${params.row?.IsSubMenu}`}
                density='compact'
                slots={{
                  noRowsOverlay: CustomNoRows
                }}
              />
            </Item>
          </Grid>         
        </Grid>

        <DialogActions className='p-2'>
          <Button
            onClick={handleClose}
            variant='outlined'
            color='info'
            className='text-transform-none me-2'>
            Cancelar
          </Button>
          <Button
            onClick={saveChanges}
            variant='contained'
            color='success'
            className='text-transform-none me-2'>
            Guardar cambios
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ModalPermisos;